import { useParams, Link, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { ArrowLeft, Clock } from 'lucide-react';
import { BASE_URL, OG_IMAGE } from '../utils/seo';
import { enterUp } from '../utils/animations';
import { blogPosts } from '../data/blogPosts';
import { ArticleBody } from '../components/blog/ArticleBody';
import { PageCTA } from '../components/PageCTA';

export default function BlogPost() {
    const { slug } = useParams();
    const post = blogPosts.find((p) => p.slug === slug);
    if (!post) return <Navigate to="/blog" replace />;

    return (
        <div data-testid="blog-post-page">
            <Helmet title={`${post.title} - White Glove Hiring`}>
                <meta name="description" content={post.metaDescription} />
                <meta property="og:title" content={`${post.title} - White Glove Hiring`} />
                <meta property="og:description" content={post.excerpt} />
                <meta property="og:type" content="article" />
                <meta property="og:url" content={`${BASE_URL}/blog/${post.slug}`} />
                <meta property="og:image" content={OG_IMAGE} />
                <link rel="canonical" href={`${BASE_URL}/blog/${post.slug}`} />
            </Helmet>

            <section className="bg-navy-900 hero-pattern pt-36 pb-16">
                <div className="max-w-3xl mx-auto px-6 lg:px-12">
                    <motion.div {...enterUp}>
                        <Link to="/blog" className="inline-flex items-center gap-2 text-gray-300 text-sm hover:text-gold-400 transition-colors mb-6" data-testid="back-to-blog">
                            <ArrowLeft size={14} /> All Articles
                        </Link>
                        <div className="flex items-center gap-4 mb-4">
                            <span className="text-gold-400 text-xs font-bold tracking-[0.25em] uppercase">{post.category}</span>
                            <span className="flex items-center gap-1.5 text-gray-400 text-xs">
                                <Clock size={12} strokeWidth={1.5} /> {post.readTime}
                            </span>
                        </div>
                        <h1 className="font-montserrat font-black text-3xl md:text-4xl lg:text-5xl text-white tracking-tight leading-tight">
                            {post.title}
                        </h1>
                    </motion.div>
                </div>
            </section>

            <section className="bg-white py-16 md:py-24">
                <ArticleBody content={post.content} />
            </section>

            <PageCTA
                headline="Ready to Stop Reading and Start Building?"
                sub="One conversation. No pressure. We'll tell you exactly what we'd recommend and why."
                testId="blog-post-cta"
            />
        </div>
    );
}
